import React, { useEffect, useState } from 'react'
import { Header } from '../Header/Header'
import { Footer } from '../Footer/Footer'
import CookieBanner from 'components/CookieBanner'
import { isLangRightToLeft } from 'utils/translations'
import { useLocation } from '@reach/router'
import { animateScroll as scroll } from 'react-scroll'
import FloatingButton from 'components/FloatingButton'
import CookieBanner2 from 'components/CookieBanner2'
import { graphql, useStaticQuery } from 'gatsby'
import useiCloudReady from 'hooks/useiCloudReady'
import { SearchProvider } from 'components/Search/SearchContext'
import { UserProvider } from 'hooks/useUser'
import { IMenu } from 'components/PostLayout/types'
import { LayoutProvider } from 'hooks/useLayoutData'
import { Mobile as MobileNav } from 'components/MainNav'

// import './Fonts.scss'
import './Layout.scss'
import './SkeletonLoading.css'
import './DarkMode.scss'

const Layout = ({
    children,
    className = '',
    style = '',
    language = 'en',
    parent,
    headerType,
    activeInternalMenu,
    logo = 'Icloudready',
}: {
    children: React.ReactNode
    className?: string
    style?: string
    language?: string
    headerType?: string
    parent?: IMenu
    activeInternalMenu?: IMenu
    logo?: string
}): JSX.Element => {
    const data = useStaticQuery(query)
    const layout = data?.layoutData?.nodes[0]?.parent?.layout
    const logoFileName = layout?.logoFileName
    const { hash } = useLocation()
    const icloudready = useiCloudReady()
    const dir = isLangRightToLeft(language) ? 'rtl' : 'ltr'

    useEffect(() => {
        if (window && icloudready) {
            icloudready.people.set({ preferred_theme: (window as any).__theme })
        }
        if (hash) scroll.scrollMore(-108)
    }, [])
    const [isCookieBannerVisible, setIsCookieBannerVisible] = useState(false)

    return (
        <SearchProvider>
            <LayoutProvider parent={parent} activeInternalMenu={activeInternalMenu}>
                <UserProvider>
                    <div dir={dir} className={className}>
                        <Header type={headerType} logo={logoFileName} />
                        <main className={style}>{children}</main>
                        <Footer />
                        <CookieBanner />
                        {/* <MobileNav /> */}
                        {/* <CookieBanner2
        isCookieBannerVisible={isCookieBannerVisible}
        setIsCookieBannerVisible={setIsCookieBannerVisible}
      />
      <FloatingButton isCookieBannerVisible={isCookieBannerVisible} /> */}
                    </div>
                </UserProvider>
            </LayoutProvider>
        </SearchProvider>
    )
}

const query = graphql`
    {
        layoutData: allMdx(filter: { fields: { slug: { regex: "/^/layout/" } } }) {
            nodes {
                parent {
                    ... on GoogleDocs {
                        id
                        layout {
                            brand
                            fonts {
                                fontFamily
                                src {
                                    url
                                    format
                                }
                                fontWeight
                                fontStyle
                                fontDisplay
                            }
                            variables {
                                key
                                value
                            }
                            sidebars {
                                name
                                items {
                                    name
                                    url
                                    enable
                                    badge {
                                        title
                                        className
                                        title_ar
                                    }
                                    children {
                                        name
                                        url
                                        enable
                                        badge {
                                            title
                                            className
                                            title_ar
                                        }
                                        children {
                                            name
                                            url
                                            enable
                                            badge {
                                                title
                                                className
                                                title_ar
                                            }
                                            children {
                                                name
                                                url
                                                enable
                                                badge {
                                                    title
                                                    className
                                                    title_ar
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            sidebars_ar {
                                name
                                items {
                                    name
                                    url
                                    enable
                                    badge {
                                        title
                                        className
                                        title_ar
                                    }
                                    children {
                                        name
                                        url
                                        enable
                                        badge {
                                            title
                                            className
                                            title_ar
                                        }
                                        children {
                                            name
                                            url
                                            enable
                                            badge {
                                                title
                                                className
                                                title_ar
                                            }
                                            children {
                                                name
                                                url
                                                enable
                                                badge {
                                                    title
                                                    className
                                                    title_ar
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            variables {
                                key
                                value
                            }
                            logoFileName
                        }
                    }
                }
            }
        }
    }
`

export default Layout
export { Layout }
export { Container, Row, Col } from './Layout2'
